import React, { useEffect, useState } from 'react';
import * as xmljs from 'xml2js';
import { Input, Form, Select } from 'antd';
import { Http } from '../../../../helpers/axois';
import { useSelector } from 'react-redux';
import { AppState } from '../../../../stateManager/store';
import formValidation from '../../../../utils/deployment-form-validation';

const { Option } = Select;
const { TextArea } = Input;

interface Props {
    data: any
    appDetails: any
    error: any
    setIsFormSelected: any;
}

const NewVersion: React.FC<Props> = (props) => {

    const appId = props.appDetails && props.appDetails.appId;
    const appInfo = useSelector((state: any) => state.apps.selectedApp)
    const [bpnmList, setbpnmList] = useState<any[]>([]);
    const [count, setcount] = useState(0);
    const appversion: { currentVersion: boolean, versionId: string } = useSelector((state: AppState) => state.apps.appVersion[appId])
    // const currentVersion = appversion.currentVersion;
    useEffect(() => {
        if (count === 0) {
            Http.get(`apps/${appId}/bpmn?versionId=${appversion.versionId}`).subscribe((res: any) => {
                setcount(1)
                props.appDetails && props.data('versionTag', props.appDetails.versionTag)
                setbpnmList(res);
            })
        }
        return () => {
            //   bpnmunsub && bpnmunsub.unsubscribe();
        };
    }, [bpnmList, appId, count, props, appversion])

    const handleChange = async (e: any) => {
        props.setIsFormSelected(true)
        props.data('bpmnId', e)
        const data = bpnmList.filter(el => el.bpmnId === e);
        const formsource = data[0].source;
        const parsedXML: any = await xmljs.parseStringPromise(formsource);
        const findTask = parsedXML["bpmn:definitions"]["bpmn:process"][0]
        let isValidForm = true;
        if (bpnmList && bpnmList.length > 0) {
            isValidForm = formValidation(findTask, isValidForm)
        }
        props.setIsFormSelected(isValidForm)
    }

    return (
        <React.Fragment>
            <div className="row override-content">
                {
                    appInfo && appInfo.type === 'a8flow' && <div className={"col-md-12"}>
                        <Form.Item
                            label={"Journey"}
                            className='tour_journey_name'
                        >
                            <Select dropdownClassName='journey_name_dropdown' data-test-id="select_bpmn" onChange={handleChange} style={{ width: '100%' }} loading={!bpnmList}>
                                {
                                    bpnmList && bpnmList.length > 0 && bpnmList.map((data: any, key: number) => {
                                        return (
                                            <Option data-test-id={`bpmn_option${data.bpmnName}`} value={data.bpmnId} key={key}>{data.bpmnName}</Option>
                                        );
                                    })
                                }
                            </Select>
                        </Form.Item>
                    </div>
                }

                <div className={"col-md-12"}>
                    <Form.Item
                        className='tour_journey_version'
                        label={"Version Tag"}
                    >
                        <Input data-test-id="version_tag" defaultValue={props.appDetails && props.appDetails.versionTag} onChange={(e) => props.data('versionTag', e.target.value)} />
                    </Form.Item>
                </div>
                <div className='col-md-12'>
                    <Form.Item
                        className='tour_journey_release_notes'
                        label={"Release Notes"}
                    >
                        <TextArea data-test-id="releaseNotes" rows={4} onChange={(e) => props.data('releaseNotes', e.target.value)} />
                    </Form.Item>
                </div>
            </div>
        </React.Fragment>
    )

}


export default NewVersion;